export default "__VITE_ASSET__Dphqk44w__"